/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type StudentReportState from '@linc-technologies/linced-common/enums/reports/student-report-state';
import type Person from '@linc-technologies/linced-common/models/person';
import type ReportTemplate from '@linc-technologies/linced-common/models/reports/report-template';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: reports.StudentReport.
export default class StudentReport extends Model {
  declare [Type]: 'reports/student-report';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @belongsTo('person', { async: true, inverse: null })
  declare studentId: AsyncBelongsTo<Person>;

  @alias('studentId')
  declare student: AsyncBelongsTo<Person>;

  @belongsTo('reports/report-template', { async: true, inverse: null })
  declare reportTemplateId: AsyncBelongsTo<ReportTemplate>;

  @alias('reportTemplateId')
  declare reportTemplate: AsyncBelongsTo<ReportTemplate>;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('number')
  declare createTime: number | undefined;

  @attr('number', { defaultValue: 0 })
  declare periodIndex: number;

  @attr('number', { defaultValue: 0 })
  declare year: number;

  @attr('number', { defaultValue: 0 })
  declare state: EnumValue<typeof StudentReportState>;

  @array('string')
  declare assignedTo: StatefulArray<string>;

  @attr('string')
  declare next: string | undefined;
}
